import React, { memo, useState } from 'react'
import { graphql } from 'gatsby'

import PageLayout, { CategoryNav, PageNav } from '~layouts/PageLayout'
import Head from '~components/Head'
import Page from '~components/Page'

import './_fields'

const MarkdownPage = ({
  data, pageContext
}) => {
  const [displaySidebar, setDisplaySidebar] = useState(false)

  return (
    <PageLayout alignment='narrow' displaySidebar={displaySidebar} setDisplaySidebar={setDisplaySidebar}>
      <Head title={pageContext.title} />
      <CategoryNav page={data.page} />
      <Page page={data.page} setDisplaySidebar={setDisplaySidebar} />
      <PageNav page={data.page} />
    </PageLayout>
  )
}

export default memo(MarkdownPage)

export const query = graphql`
  query($id: String!) {
    page: markdownRemark(id: {
      eq: $id
    }) {
      ...pageFields
    }
  }
`
